<div class="mb-2 mat-title-small">{{ 'catalog.settings.search_title' | transloco }}</div>

<mat-form-field class="w-full">
  <mat-label>{{ 'catalog.settings.search_default_logical_operator' | transloco }}</mat-label>
  <mat-select (valueChange)="logicalOperatorChange.emit($event)" [value]="logicalOperator"
              id="select-logical-operator">
    @for (logOp of logicalOperators; track logOp) {
      <mat-option [value]="logOp">
        {{ logOp }}
      </mat-option>
    }
  </mat-select>
</mat-form-field>

<mat-form-field class="w-full">
  <mat-label>{{ 'catalog.settings.search_form_mode' | transloco }}</mat-label>
  <mat-select (valueChange)="searchFormModeChange.emit($event)" [value]="searchFormMode" id="select-search-form-mode">
    @for (sfm of searchFormModes; track sfm) {
      <mat-option [value]="sfm">
        {{ 'catalog.settings.search_form_modes.' + sfm | transloco }}
      </mat-option>
    }
  </mat-select>
</mat-form-field>

@for (key of getKeys(formSettings); track key) {
  <div class="mb-2">
    <mat-slide-toggle
      (change)="formSettingToggle.emit(key)"
      [checked]="formSettings[key]"
      [id]="'search-settings-' + key"
      class="primary-slide-toggle"
    >
      <div class="flex items-center">
        <mat-icon
          class="mx-1"
          [title]="getLabel(key) | transloco"
        >{{ getIcon(key) }}
        </mat-icon>
        {{ getLabel(key) | transloco }}
      </div>
    </mat-slide-toggle>
  </div>
}
